// Tamanhos
export const SIZE_TITLE     = '3rem'
export const SIZE_SUBTITLE  = '1.5rem'
export const SIZE_TEXT      = '1rem'

// Font Family
export const PRIMARY_FONT   = 'Kaushan Script'
export const SECOND_FONT    = 'Kaushan Script'
